import type { CandidateRecord } from '../types/market.js';
import { isPredictorCandidate } from './candidateQualification.js';
import { mergeCandidateWithLiveObservation } from './candidateLiveMerge.js';

/**
 * Select the currently Core-qualified candidates for independent supporting
 * evaluation. The worker observation is always merged with the existing deep
 * Core thesis first; raw observations are intentionally not eligible because
 * they begin with deepValidated=false and may still have a neutral direction.
 */
export function selectSupportingCandidates(
  observations: CandidateRecord[],
  deepRecords: Map<string, CandidateRecord>,
  minimumDataQuality: number,
  limit: number,
): CandidateRecord[] {
  return observations
    .map((candidate) => mergeCandidateWithLiveObservation(candidate, deepRecords.get(candidate.id)))
    .filter((candidate) => isPredictorCandidate(candidate, minimumDataQuality))
    .sort(
      (left, right) =>
        right.candidateScore - left.candidateScore ||
        right.movementStrength - left.movementStrength ||
        left.id.localeCompare(right.id),
    )
    .slice(0, limit);
}
